import { ApplicationRef, ChangeDetectionStrategy, Component, inject, OnDestroy, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterOutlet } from '@angular/router';
import { SwUpdate } from '@angular/service-worker';
import { ValToastComponent } from '@valamar/val-toast';
import { concat, first, interval, Subject, takeUntil, tap } from 'rxjs';
import packg from '../../package.json';
import { VrcStorageService } from './services/vrc-storage.service';
@Component({
  selector: 'app-root',
  imports: [RouterOutlet, FormsModule, ValToastComponent],
  templateUrl: './app.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit, OnDestroy {
  private _swUpdate = inject(SwUpdate);
  private _st = inject(VrcStorageService);
  private _appRef = inject(ApplicationRef);

  private readonly _destroying$ = new Subject<void>();
  public title = 'Guest 360 view';
  public appVersion = packg.version;
  constructor() {
    if (window.location.href.indexOf('isMerge') > -1) {
      window.addEventListener('message', this._handleMessage);
    }
    if (this._swUpdate.isEnabled) {
      const appIsStable$ = this._appRef.isStable.pipe(first(isStable => isStable === true));
      const everyMinute$ = interval(60 * 1000); // Every 1 minutes
      const everyMinuteOnceAppIsStable$ = concat(appIsStable$, everyMinute$);
      everyMinuteOnceAppIsStable$.pipe(
        takeUntil(this._destroying$),
        tap(() => {
          this._swUpdate.checkForUpdate().then(x => {
            if (x) {
              if (confirm('New application version is available. Load New Version?')) {
                location.reload();
              }
            }
          }, r => { console.log('Check for update executed and rejected, reason: ' + r) });
        }),
      ).subscribe();

      this._swUpdate.versionUpdates.pipe(
        takeUntil(this._destroying$),
        tap((evt) => {
          if (evt.type === 'VERSION_READY') {
            if (confirm('New application version is available. Load New Version?')) {
              location.reload();
            }
          }
        })).subscribe();
    }
  }

  ngOnInit(): void {
    this._st.isCreateLoyalty.set(false);
  }

  ngOnDestroy(): void {
    this._destroying$.next(undefined);
    this._destroying$.complete();
    window.removeEventListener('message', this._handleMessage);
  }

  private _handleMessage = (event: Event) => {
    const messageevent = event as MessageEvent;
    if (messageevent.origin === location.origin) {
      this._st.parentWindow = messageevent.source as WindowProxy;
    }
  }
}
